// Placeholder animado que imita la forma de una InfoCard mientras se cargan los posts.
// Reemplaza el texto "Cargando..." por bloques grises con animación de pulso,
// lo que da una mejor experiencia visual al usuario.

import React from 'react';
import styles from './InfoCard.module.css';

// Muestra una tarjeta gris con animación mientras el contenido real está cargando
const SkeletonCard = () => (
  <div className={styles['card-wrapper']}>
    <div className={`${styles['card']} ${styles['skeleton']}`}>
      <div className={styles['skeleton-image']} />
      <div className={styles['card-content']}>
        <div className={`${styles['skeleton-line']} ${styles['skeleton-title']}`} />
        <div className={styles['skeleton-line']} />
        <div className={`${styles['skeleton-line']} ${styles['skeleton-short']}`} />
      </div>
    </div>
  </div>
);

export default SkeletonCard;
